// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { GiHamburgerMenu } from "react-icons/gi";
// import { IoIosArrowForward } from "react-icons/io";
// import { motion, AnimatePresence } from "framer-motion";
// import { X, Home, ShoppingCart, Heart, User } from "lucide-react";
// import { useTranslation } from "react-i18next";
// import { useCart } from "../../utils/CartContext";

// const BottomNavbar = () => {
//   const { t, i18n } = useTranslation();
//   const [activeMegaMenu, setActiveMegaMenu] = useState(null);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [mobileExpandedCat, setMobileExpandedCat] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [megaMenuData, setMegaMenuData] = useState({}); 
//   const navigate = useNavigate();
//   const navRef = useRef(null);
//   const currentLanguage = i18n.language || "en";
//   const hoverTimeout = useRef(null);
//   const { cartCount } = useCart();

//   // ── Fetch categories ──
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/categories/get-all-categories`
//         );
//         setCategories(response.data);
//       } catch (error) {
//         console.error("Error fetching categories:", error);
//       }
//     };
//     fetchCategories();
//   }, []);

//   // ── Fetch mega menu data for a category (cached) ──
//   const fetchMegaMenuData = useCallback(async (categoryId) => {
//     // Already loaded or loading
//     if (megaMenuData[categoryId]) return;

//     setMegaMenuData((prev) => ({
//       ...prev,
//       [categoryId]: { data: [], loading: true },
//     }));

//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/products/category-mega-menu/${categoryId}`
//       );
//       setMegaMenuData((prev) => ({
//         ...prev,
//         [categoryId]: { data: res.data.data || [], loading: false },
//       }));
//     } catch (error) {
//       console.error("Mega menu fetch error:", error);
//       setMegaMenuData((prev) => ({
//         ...prev,
//         [categoryId]: { data: [], loading: false },
//       }));
//     }
//   }, [megaMenuData]);

//   // ── Localization helpers (DO NOT MODIFY) ──
//   const getLocalizedName = (category) => {
//     if (!category || !category.name) return "";
//     if (typeof category.name === "string") return category.name;
//     if (typeof category.name === "object") {
//       return (
//         category.name[currentLanguage] ||
//         category.name.en ||
//         category.name.hi ||
//         category.name.es ||
//         category.name.zh ||
//         "Category"
//       );
//     }
//     return "Category";
//   };

//   const getLocalizedDescription = (category) => {
//     if (!category || !category.description) return "";
//     if (typeof category.description === "string") return category.description;
//     if (typeof category.description === "object") {
//       return (
//         category.description[currentLanguage] ||
//         category.description.en ||
//         category.description.hi ||
//         category.description.es ||
//         category.description.zh ||
//         ""
//       );
//     }
//     return "";
//   };

//   const handleNavigate = (path) => {
//     navigate(path);
//     setActiveMegaMenu(null);
//     setMobileOpen(false);
//     setMobileExpandedCat(null);
//     window.scrollTo(0, 0);
//   };

//   // ── Close mega menu on outside click ──
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (navRef.current && !navRef.current.contains(e.target)) {
//         setActiveMegaMenu(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleMouseEnterCategory = (id) => {
//     clearTimeout(hoverTimeout.current);
//     setActiveMegaMenu(id);
//     fetchMegaMenuData(id); // fetch products when hovering
//   };

//   const handleMouseLeaveNav = () => {
//     hoverTimeout.current = setTimeout(() => {
//       setActiveMegaMenu(null);
//     }, 150);
//   };

//   const handleMouseEnterMega = () => {
//     clearTimeout(hoverTimeout.current);
//   };

//   const activeCategoryData = categories.find((c) => c._id === activeMegaMenu);
//   const activeMenuContent = megaMenuData[activeMegaMenu];

//   return (
//     <div className="w-full relative shadow-sm" ref={navRef}>
//       {/* DESKTOP NAVBAR */}
//       <div className="hidden xl:flex items-center justify-center px-4 md:px-10 py-2 bg-[#232F3E] text-white relative z-30">
//         <div className="flex items-center gap-8">
//           {categories.map((item) => (
//             <div
//               key={item._id}
//               className={`relative cursor-pointer text-[16px] font-normal tracking-wider whitespace-nowrap transition-colors pb-1 ${
//                 activeMegaMenu === item._id
//                   ? "text-yellow-400 border-b-2 border-yellow-400"
//                   : "hover:text-yellow-400"
//               }`}
//               onMouseEnter={() => handleMouseEnterCategory(item._id)}
//               onMouseLeave={handleMouseLeaveNav}
//               onClick={() => handleNavigate(`/category/${item._id}`)}
//             >
//               {getLocalizedName(item)}
//             </div>
//           ))}
//         </div>
//       </div>

//       <AnimatePresence>
//         {activeMegaMenu && activeCategoryData && (
//           <motion.div
//             key={activeMegaMenu}
//             initial={{ opacity: 0, y: -8 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -8 }}
//             transition={{ duration: 0.18 }}
//             className="hidden xl:block absolute left-0 right-0 top-full w-full bg-white shadow-2xl border-t-2 border-yellow-400 z-20"
//             onMouseEnter={handleMouseEnterMega}
//             onMouseLeave={handleMouseLeaveNav}
//           >
//             <div className="w-full px-10 py-6">
//               <div className="flex gap-8">

//                 {/* ── Left panel: Category image + name ── */}
//                 <div className="flex-shrink-0 w-44 flex flex-col items-center justify-start pt-1 border-r border-gray-100 pr-8">
//                   {activeCategoryData.imgUrl && (
//                     <div className="w-32 h-32 rounded-xl overflow-hidden shadow-md mb-3">
//                       <img
//                         src={activeCategoryData.imgUrl}
//                         alt={getLocalizedName(activeCategoryData)}
//                         className="w-full h-full object-cover"
//                         onError={(e) => {
//                           e.target.parentElement.style.display = "none";
//                         }}
//                       />
//                     </div>
//                   )}
//                   <h3 className="text-sm font-bold text-[#232F3E] text-center font-philosopher leading-snug">
//                     {getLocalizedName(activeCategoryData)}
//                   </h3>
//                   <button
//                     onClick={() =>
//                       handleNavigate(`/category/${activeCategoryData._id}`)
//                     }
//                     className="mt-3 text-xs text-yellow-600 font-semibold hover:underline flex items-center gap-1"
//                   >
//                     View All <IoIosArrowForward />
//                   </button>
//                 </div>

//                 {/* ── Right panel: Subcategories + Product Names Only ── */}
//                 <div className="flex-1 overflow-y-auto max-h-[70vh]">
//                   {activeMenuContent?.loading ? (
//                     // Loading skeleton - updated to match product names layout
//                     <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
//                       {[...Array(3)].map((_, i) => (
//                         <div key={i} className="animate-pulse">
//                           <div className="h-4 bg-gray-200 rounded w-24 mb-3" />
//                           <div className="flex flex-col gap-2">
//                             {[...Array(4)].map((_, j) => (
//                               <div key={j} className="h-4 bg-gray-200 rounded w-3/4" />
//                             ))}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   ) : activeMenuContent?.data?.length > 0 ? (
//                     // Subcategories with products - product names only
//                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//                       {activeMenuContent.data.map((group) => (
//                         <div key={group.subCategory._id}>
//                           {/* Subcategory header */}
//                           <div
//                             className="flex items-center gap-2 mb-3 cursor-pointer group"
//                             onClick={() =>
//                               handleNavigate(`/category/${activeMegaMenu}`)
//                             }
//                           >
//                             {group.subCategory.imgUrl && (
//                               <div className="w-7 h-7 rounded-full overflow-hidden border border-gray-200 flex-shrink-0">
//                                 <img
//                                   src={group.subCategory.imgUrl}
//                                   alt={getLocalizedName(group.subCategory)}
//                                   className="w-full h-full object-cover"
//                                   onError={(e) => {
//                                     e.target.parentElement.style.display = "none";
//                                   }}
//                                 />
//                               </div>
//                             )}
//                             <span className="text-xs font-bold uppercase tracking-wider text-[#232F3E] group-hover:text-orange-500 transition-colors border-b-2 border-yellow-400 pb-0.5">
//                               {getLocalizedName(group.subCategory)}
//                             </span>
//                           </div>

//                           {/* Products under this subcategory - Display ONLY product names as clickable links */}
//                           {group.products && group.products.length > 0 ? (
//                             <div className="flex flex-col gap-0.5">
//                               {group.products.map((product) => {
//                                 const productName = getLocalizedName(product);
//                                 return (
//                                   <div
//                                     key={product._id}
//                                     onClick={() =>
//                                       handleNavigate(`/product-details/${product._id}`)
//                                     }
//                                     className="cursor-pointer px-2 py-1.5 hover:bg-orange-50 rounded-md transition-colors duration-150 flex items-center"
//                                   >
//                                     <span className="text-sm text-gray-700 hover:text-orange-600 font-medium line-clamp-2">
//                                       {productName || "Unnamed Product"}
//                                     </span>
//                                   </div>
//                                 );
//                               })}
//                             </div>
//                           ) : (
//                             <p className="text-xs text-gray-400 italic px-2 py-1">
//                               No products yet
//                             </p>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     // Fallback: show subcategories from category data only (no products)
//                     activeCategoryData.subcategories?.length > 0 ? (
//                       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-1">
//                         {activeCategoryData.subcategories.map((sub) => (
//                           <div
//                             key={sub._id}
//                             onClick={() =>
//                               handleNavigate(`/category/${activeCategoryData._id}`)
//                             }
//                             className="group flex items-center gap-3 py-2 px-2 rounded-lg hover:bg-orange-50 cursor-pointer transition-colors"
//                           >
//                             <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">
//                               <img
//                                 src={sub.imgUrl}
//                                 alt={getLocalizedName(sub)}
//                                 className="w-full h-full object-cover"
//                                 onError={(e) => {
//                                   e.target.src =
//                                     "https://via.placeholder.com/40x40?text=?";
//                                 }}
//                               />
//                             </div>
//                             <span className="text-sm text-gray-800 font-medium group-hover:text-orange-600 transition-colors">
//                               {getLocalizedName(sub)}
//                             </span>
//                           </div>
//                         ))}
//                       </div>
//                     ) : (
//                       <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
//                         {t("no_subcategories") || "No subcategories available"}
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* MOBILE NAVBAR */}
//       <div className="xl:hidden flex justify-between items-center px-4 py-3 bg-[#232F3E] text-white">
//         <div className="flex items-center gap-2">
//           <GiHamburgerMenu
//             size={24}
//             className="cursor-pointer"
//             onClick={() => setMobileOpen(!mobileOpen)}
//           />
//           <span className="font-semibold">{t("menu")}</span>
//         </div>
        
//         {/* Mobile Cart Icon with Count */}
//         <div 
//           className="relative cursor-pointer hover:text-yellow-400 transition-colors"
//           onClick={() => handleNavigate("/cart")}
//         >
//           <ShoppingCart className="w-6 h-6" />
//           {cartCount > 0 && (
//             <span className="absolute -top-2 -right-2 bg-yellow-400 text-black text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
//               {cartCount}
//             </span>
//           )}
//         </div>
//       </div>

//       <AnimatePresence>
//         {mobileOpen && (
//           <>
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               transition={{ duration: 0.3 }}
//               className="fixed inset-0 bg-black bg-opacity-50 z-40"
//               onClick={() => setMobileOpen(false)}
//             />
//             <motion.div
//               initial={{ x: "-100%" }}
//               animate={{ x: 0 }}
//               exit={{ x: "-100%" }}
//               transition={{ duration: 0.3, ease: "easeInOut" }}
//               className="fixed top-0 left-0 w-4/5 max-w-sm h-full bg-white shadow-2xl z-50 overflow-y-auto"
//             >
//               <div className="bg-[#232F3E] text-white p-4 relative">
//                 <button
//                   className="absolute top-4 right-4 text-white hover:text-gray-300"
//                   onClick={() => setMobileOpen(false)}
//                 >
//                   <X className="w-6 h-6" />
//                 </button>
//                 <div className="mt-2">
//                   <h2 className="text-2xl font-bold font-philosopher">
//                     Bharat Karigari
//                   </h2>
//                 </div>
//               </div>

//               <div className="bg-white">
//                 {/* Home */}
//                 <div
//                   className="flex items-center justify-between px-6 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50"
//                   onClick={() => handleNavigate("/")}
//                 >
//                   <div className="flex items-center gap-3">
//                     <Home className="w-5 h-5 text-gray-700" />
//                     <span className="text-base font-semibold font-philosopher text-gray-900">
//                       {t("home")}
//                     </span>
//                   </div>
//                 </div>

//                 {/* Wishlist */}
//                 <div
//                   className="flex items-center justify-between px-6 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50"
//                   onClick={() => handleNavigate("/wishlist")}
//                 >
//                   <div className="flex items-center gap-3">
//                     <Heart className="w-5 h-5 text-gray-700" />
//                     <span className="text-base font-semibold font-philosopher text-gray-900">
//                       {t("wishlist") || "Wishlist"}
//                     </span>
//                   </div>
//                 </div>

//                 {/* Cart */}
//                 <div
//                   className="flex items-center justify-between px-6 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50"
//                   onClick={() => handleNavigate("/cart")}
//                 >
//                   <div className="flex items-center gap-3">
//                     <ShoppingCart className="w-5 h-5 text-gray-700" />
//                     <span className="text-base font-semibold font-philosopher text-gray-900">
//                       {t("cart") || "Cart"}
//                     </span>
//                     {cartCount > 0 && (
//                       <span className="bg-yellow-400 text-black text-xs font-bold px-2 py-0.5 rounded-full">
//                         {cartCount}
//                       </span>
//                     )}
//                   </div>
//                 </div>

//                 {/* Categories */}
//                 <div className="px-6 py-4 border-b border-gray-200">
//                   <h3 className="text-lg font-bold text-gray-900 mb-3">
//                     {t("topDepartments")}
//                   </h3>
//                   <div className="space-y-1">
//                     {categories.map((item) => (
//                       <div key={item._id}>
//                         <div
//                           className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50 -mx-2 px-2 rounded"
//                           onClick={() => {
//                             if (item.subcategories?.length > 0) {
//                               setMobileExpandedCat(
//                                 mobileExpandedCat === item._id ? null : item._id
//                               );
//                             } else {
//                               handleNavigate(`/category/${item._id}`);
//                             }
//                           }}
//                         >
//                           <div className="flex items-center gap-3">
//                             {item.catIconUrl && (
//                               <img
//                                 src={item.catIconUrl}
//                                 alt={getLocalizedName(item)}
//                                 className="w-6 h-6 object-contain"
//                               />
//                             )}
//                             <span className="text-sm text-gray-900 font-normal">
//                               {getLocalizedName(item)}
//                             </span>
//                           </div>
//                           <IoIosArrowForward
//                             className={`text-gray-400 text-sm transition-transform duration-200 ${
//                               mobileExpandedCat === item._id ? "rotate-90" : ""
//                             }`}
//                           />
//                         </div>

//                         <AnimatePresence>
//                           {mobileExpandedCat === item._id &&
//                             item.subcategories?.length > 0 && (
//                               <motion.div
//                                 initial={{ height: 0, opacity: 0 }}
//                                 animate={{ height: "auto", opacity: 1 }}
//                                 exit={{ height: 0, opacity: 0 }}
//                                 transition={{ duration: 0.2 }}
//                                 className="overflow-hidden"
//                               >
//                                 <div className="pl-4 pb-2 space-y-1 border-l-2 border-orange-200 ml-4">
//                                   <div
//                                     className="flex items-center gap-2 py-2 px-2 cursor-pointer hover:bg-orange-50 rounded text-orange-600 font-semibold text-xs"
//                                     onClick={() =>
//                                       handleNavigate(`/category/${item._id}`)
//                                     }
//                                   >
//                                     View All {getLocalizedName(item)}
//                                   </div>
//                                   {item.subcategories.map((sub) => (
//                                     <div
//                                       key={sub._id}
//                                       className="flex items-center gap-3 py-2 px-2 cursor-pointer hover:bg-gray-50 rounded"
//                                       onClick={() =>
//                                         handleNavigate(`/category/${item._id}`)
//                                       }
//                                     >
//                                       <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-100 flex-shrink-0">
//                                         <img
//                                           src={sub.imgUrl}
//                                           alt={getLocalizedName(sub)}
//                                           className="w-full h-full object-cover"
//                                           onError={(e) => {
//                                             e.target.src =
//                                               "https://via.placeholder.com/32x32?text=?";
//                                           }}
//                                         />
//                                       </div>
//                                       <span className="text-sm text-gray-700">
//                                         {getLocalizedName(sub)}
//                                       </span>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </motion.div>
//                             )}
//                         </AnimatePresence>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="px-6 py-4">
//                   <button
//                     className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900"
//                     onClick={() => {
//                       navigate("/categories");
//                       setMobileOpen(false);
//                     }}
//                   >
//                     <span>{t("seeAll")}</span>
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 9l-7 7-7-7"
//                       />
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//             </motion.div>
//           </>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default BottomNavbar;



import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoIosArrowForward } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { X, Home } from "lucide-react";
import { useTranslation } from "react-i18next";

const BottomNavbar = () => {
  const { t, i18n } = useTranslation();
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpandedCat, setMobileExpandedCat] = useState(null);
  const [categories, setCategories] = useState([]);
  const [megaMenuData, setMegaMenuData] = useState({}); 
  const navigate = useNavigate();
  const navRef = useRef(null);
  const currentLanguage = i18n.language || "en";
  const hoverTimeout = useRef(null);

  // ── Fetch categories ──
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/categories/get-all-categories`
        );
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  // ── Fetch mega menu data for a category (cached) ──
  const fetchMegaMenuData = useCallback(async (categoryId) => {
    // Already loaded or loading
    if (megaMenuData[categoryId]) return;

    setMegaMenuData((prev) => ({
      ...prev,
      [categoryId]: { data: [], loading: true },
    }));

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/category-mega-menu/${categoryId}`
      );
      setMegaMenuData((prev) => ({
        ...prev,
        [categoryId]: { data: res.data.data || [], loading: false },
      }));
    } catch (error) {
      console.error("Mega menu fetch error:", error);
      setMegaMenuData((prev) => ({
        ...prev,
        [categoryId]: { data: [], loading: false },
      }));
    }
  }, [megaMenuData]);

  // ── Localization helpers (DO NOT MODIFY) ──
  const getLocalizedName = (category) => {
    if (!category || !category.name) return "";
    if (typeof category.name === "string") return category.name;
    if (typeof category.name === "object") {
      return (
        category.name[currentLanguage] ||
        category.name.en ||
        category.name.hi ||
        category.name.es ||
        category.name.zh ||
        "Category"
      );
    }
    return "Category";
  };

  const getLocalizedDescription = (category) => {
    if (!category || !category.description) return "";
    if (typeof category.description === "string") return category.description;
    if (typeof category.description === "object") {
      return (
        category.description[currentLanguage] ||
        category.description.en ||
        category.description.hi ||
        category.description.es ||
        category.description.zh ||
        ""
      );
    }
    return "";
  };

  const handleNavigate = (path) => {
    navigate(path);
    setActiveMegaMenu(null);
    setMobileOpen(false);
    setMobileExpandedCat(null);
    window.scrollTo(0, 0);
  };

  // ── Close mega menu on outside click ──
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActiveMegaMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMouseEnterCategory = (id) => {
    clearTimeout(hoverTimeout.current);
    setActiveMegaMenu(id);
    fetchMegaMenuData(id); // fetch products when hovering
  };

  const handleMouseLeaveNav = () => {
    hoverTimeout.current = setTimeout(() => {
      setActiveMegaMenu(null);
    }, 150);
  };

  const handleMouseEnterMega = () => {
    clearTimeout(hoverTimeout.current);
  };

  const activeCategoryData = categories.find((c) => c._id === activeMegaMenu);
  const activeMenuContent = megaMenuData[activeMegaMenu];

  return (
    <div className="w-full relative shadow-sm" ref={navRef}>
      {/* DESKTOP NAVBAR */}
      <div className="hidden xl:flex items-center justify-center px-4 md:px-10 py-2 bg-[#232F3E] text-white relative z-30">
        <div className="flex items-center gap-8">
          {categories.map((item) => (
            <div
              key={item._id}
              className={`relative cursor-pointer text-[16px] font-normal tracking-wider whitespace-nowrap transition-colors pb-1 ${
                activeMegaMenu === item._id
                  ? "text-yellow-400 border-b-2 border-yellow-400"
                  : "hover:text-yellow-400"
              }`}
              onMouseEnter={() => handleMouseEnterCategory(item._id)}
              onMouseLeave={handleMouseLeaveNav}
              onClick={() => handleNavigate(`/category/${item._id}`)}
            >
              {getLocalizedName(item)}
            </div>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {activeMegaMenu && activeCategoryData && (
          <motion.div
            key={activeMegaMenu}
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.18 }}
            className="hidden xl:block absolute left-0 right-0 top-full w-full bg-white shadow-2xl border-t-2 border-yellow-400 z-20"
            onMouseEnter={handleMouseEnterMega}
            onMouseLeave={handleMouseLeaveNav}
          >
            <div className="w-full px-10 py-6">
              <div className="flex gap-8">

                {/* ── Left panel: Category image + name ── */}
                <div className="flex-shrink-0 w-44 flex flex-col items-center justify-start pt-1 border-r border-gray-100 pr-8">
                  {activeCategoryData.imgUrl && (
                    <div className="w-32 h-32 rounded-xl overflow-hidden shadow-md mb-3">
                      <img
                        src={activeCategoryData.imgUrl}
                        alt={getLocalizedName(activeCategoryData)}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.parentElement.style.display = "none";
                        }}
                      />
                    </div>
                  )}
                  <h3 className="text-sm font-bold text-[#232F3E] text-center font-philosopher leading-snug">
                    {getLocalizedName(activeCategoryData)}
                  </h3>
                  <button
                    onClick={() =>
                      handleNavigate(`/category/${activeCategoryData._id}`)
                    }
                    className="mt-3 text-xs text-yellow-600 font-semibold hover:underline flex items-center gap-1"
                  >
                    View All <IoIosArrowForward />
                  </button>
                </div>

                {/* ── Right panel: Subcategories + Product Names Only ── */}
                <div className="flex-1 overflow-y-auto max-h-[70vh]">
                  {activeMenuContent?.loading ? (
                    // Loading skeleton - updated to match product names layout
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
                      {[...Array(3)].map((_, i) => (
                        <div key={i} className="animate-pulse">
                          <div className="h-4 bg-gray-200 rounded w-24 mb-3" />
                          <div className="flex flex-col gap-2">
                            {[...Array(4)].map((_, j) => (
                              <div key={j} className="h-4 bg-gray-200 rounded w-3/4" />
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : activeMenuContent?.data?.length > 0 ? (
                    // Subcategories with products - product names only
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                      {activeMenuContent.data.map((group) => (
                        <div key={group.subCategory._id}>
                          {/* Subcategory header */}
                          <div
                            className="flex items-center gap-2 mb-3 cursor-pointer group"
                            onClick={() =>
                              handleNavigate(`/category/${activeMegaMenu}`)
                            }
                          >
                            {group.subCategory.imgUrl && (
                              <div className="w-7 h-7 rounded-full overflow-hidden border border-gray-200 flex-shrink-0">
                                <img
                                  src={group.subCategory.imgUrl}
                                  alt={getLocalizedName(group.subCategory)}
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.parentElement.style.display = "none";
                                  }}
                                />
                              </div>
                            )}
                            <span className="text-xs font-bold uppercase tracking-wider text-[#232F3E] group-hover:text-orange-500 transition-colors border-b-2 border-yellow-400 pb-0.5">
                              {getLocalizedName(group.subCategory)}
                            </span>
                          </div>

                          {/* Products under this subcategory - Display ONLY product names as clickable links */}
                          {group.products && group.products.length > 0 ? (
                            <div className="flex flex-col gap-0.5">
                              {group.products.map((product) => {
                                const productName = getLocalizedName(product);
                                return (
                                  <div
                                    key={product._id}
                                    onClick={() =>
                                      handleNavigate(`/product-details/${product._id}`)
                                    }
                                    className="cursor-pointer px-2 py-1.5 hover:bg-orange-50 rounded-md transition-colors duration-150 flex items-center"
                                  >
                                    <span className="text-sm text-gray-700 hover:text-orange-600 font-medium line-clamp-2">
                                      {productName || "Unnamed Product"}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <p className="text-xs text-gray-400 italic px-2 py-1">
                              No products yet
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Fallback: show subcategories from category data only (no products)
                    activeCategoryData.subcategories?.length > 0 ? (
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-1">
                        {activeCategoryData.subcategories.map((sub) => (
                          <div
                            key={sub._id}
                            onClick={() =>
                              handleNavigate(`/category/${activeCategoryData._id}`)
                            }
                            className="group flex items-center gap-3 py-2 px-2 rounded-lg hover:bg-orange-50 cursor-pointer transition-colors"
                          >
                            <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">
                              <img
                                src={sub.imgUrl}
                                alt={getLocalizedName(sub)}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/40x40?text=?";
                                }}
                              />
                            </div>
                            <span className="text-sm text-gray-800 font-medium group-hover:text-orange-600 transition-colors">
                              {getLocalizedName(sub)}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
                        {t("no_subcategories") || "No subcategories available"}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MOBILE NAVBAR — COMPLETELY UNCHANGE */}
      <div className="xl:hidden flex justify-between items-center px-4 py-3 bg-[#232F3E] text-white">
        <div className="flex items-center gap-2">
          <GiHamburgerMenu
            size={24}
            className="cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          />
          <span className="font-semibold">{t("menu")}</span>
        </div>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="fixed inset-0 bg-black bg-opacity-50 z-40"
              onClick={() => setMobileOpen(false)}
            />
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="fixed top-0 left-0 w-4/5 max-w-sm h-full bg-white shadow-2xl z-50 overflow-y-auto"
            >
              <div className="bg-[#232F3E] text-white p-4 relative">
                <button
                  className="absolute top-4 right-4 text-white hover:text-gray-300"
                  onClick={() => setMobileOpen(false)}
                >
                  <X className="w-6 h-6" />
                </button>
                <div className="mt-2">
                  <h2 className="text-2xl font-bold font-philosopher">
                    Bharat Karigari
                  </h2>
                </div>
              </div>

              <div className="bg-white">
                <div
                  className="flex items-center justify-between px-6 py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-50"
                  onClick={() => handleNavigate("/")}
                >
                  <div className="flex items-center gap-3">
                    <Home className="w-5 h-5 text-gray-700" />
                    <span className="text-base font-semibold font-philosopher text-gray-900">
                      {t("home")}
                    </span>
                  </div>
                </div>

                <div className="px-6 py-4 border-b border-gray-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    {t("topDepartments")}
                  </h3>
                  <div className="space-y-1">
                    {categories.map((item) => (
                      <div key={item._id}>
                        <div
                          className="flex items-center justify-between py-3 cursor-pointer hover:bg-gray-50 -mx-2 px-2 rounded"
                          onClick={() => {
                            if (item.subcategories?.length > 0) {
                              setMobileExpandedCat(
                                mobileExpandedCat === item._id ? null : item._id
                              );
                            } else {
                              handleNavigate(`/category/${item._id}`);
                            }
                          }}
                        >
                          <div className="flex items-center gap-3">
                            {item.catIconUrl && (
                              <img
                                src={item.catIconUrl}
                                alt={getLocalizedName(item)}
                                className="w-6 h-6 object-contain"
                              />
                            )}
                            <span className="text-sm text-gray-900 font-normal">
                              {getLocalizedName(item)}
                            </span>
                          </div>
                          <IoIosArrowForward
                            className={`text-gray-400 text-sm transition-transform duration-200 ${
                              mobileExpandedCat === item._id ? "rotate-90" : ""
                            }`}
                          />
                        </div>

                        <AnimatePresence>
                          {mobileExpandedCat === item._id &&
                            item.subcategories?.length > 0 && (
                              <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                                className="overflow-hidden"
                              >
                                <div className="pl-4 pb-2 space-y-1 border-l-2 border-orange-200 ml-4">
                                  <div
                                    className="flex items-center gap-2 py-2 px-2 cursor-pointer hover:bg-orange-50 rounded text-orange-600 font-semibold text-xs"
                                    onClick={() =>
                                      handleNavigate(`/category/${item._id}`)
                                    }
                                  >
                                    View All {getLocalizedName(item)}
                                  </div>
                                  {item.subcategories.map((sub) => (
                                    <div
                                      key={sub._id}
                                      className="flex items-center gap-3 py-2 px-2 cursor-pointer hover:bg-gray-50 rounded"
                                      onClick={() =>
                                        handleNavigate(`/category/${item._id}`)
                                      }
                                    >
                                      <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-100 flex-shrink-0">
                                        <img
                                          src={sub.imgUrl}
                                          alt={getLocalizedName(sub)}
                                          className="w-full h-full object-cover"
                                          onError={(e) => {
                                            e.target.src =
                                              "https://via.placeholder.com/32x32?text=?";
                                          }}
                                        />
                                      </div>
                                      <span className="text-sm text-gray-700">
                                        {getLocalizedName(sub)}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </motion.div>
                            )}
                        </AnimatePresence>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="px-6 py-4">
                  <button
                    className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900"
                    onClick={() => {
                      navigate("/categories");
                      setMobileOpen(false);
                    }}
                  >
                    <span>{t("seeAll")}</span>
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BottomNavbar;